import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["twitter", "Twitter Ads"],
  iconColor: "#71D5D5", // pluto
  getIcon(options) {
    return createIcon(
      `
      <g style="mix-blend-mode:darken">
        <g transform="translate(6, 6)">
          <g id="X_logo_2023_original" clip-path="url(#clip0_138_28711)">
            <path d="M7.1428 5.08175L11.6108 0H10.5524L6.6712 4.41151L3.5736 0H0L4.6852 6.67162L0 12H1.0584L5.1544 7.34026L8.4264 12H12M1.4404 0.780947H3.0664L10.5516 11.2574H8.9252" fill="currentColor"/>
          </g>
          <clipPath id="clip0_138_28711">
            <rect width="12" height="12" fill="white"/>
          </clipPath>
        </g>
      </g>
      `,
      "#F1FBFB", // pluto-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
